import BaseModule from './BaseModule';
import Factory from '../libs/Factory';
import Cookies from 'js-cookie';

const COOKIE_NAME = 'range-popup-shown';

export default class RangePopup extends BaseModule {
    constructor(el: HTMLElement, factory: Factory) {
        super(el, factory, 'RangePopup');

        const shown = Cookies.get(COOKIE_NAME);
        if(!shown){
            document.body.style.overflow = 'hidden';
            el.classList.remove('hidden');

            const expires = new Date();
            const expireTime = expires.getTime() + 30 * 24 * 60 * 60 * 1000;
            expires.setTime(expireTime);
            Cookies.set(COOKIE_NAME, true.toString(), {expires});
        }

        const close = el.querySelector('.close');
        close?.addEventListener('click', (e) => {
            document.body.style.overflow = '';
            e.preventDefault();
            el.classList.add('hidden');
        });

        const open = document.querySelector('a.rangePopup') as HTMLAnchorElement;
        if(open){
            open.addEventListener('click', (e) => {
                e.preventDefault();

                document.body.style.overflow = 'hidden';
                el.classList.remove('hidden');
            });
        }
    }
}
